import { type MeReadDtoLangEnum } from "@/config/apiClient";
import { AVAILABLE_LANGS_SET } from "@/constants/languages.constants";

/**
 * Type guard to check if a value is a supported language
 */
export const isSupportedLang = (value: unknown): value is MeReadDtoLangEnum => {
  if (typeof value !== "string") {
    return false;
  }
  return AVAILABLE_LANGS_SET.has(value);
};
